const single_sign_on = {
    forbidden_domains: 'I domini di posta elettronica pubblica non sono consentiti.',
    duplicated_domains: 'Ci sono domini duplicati.',
    /** UNTRANSLATED */
    invalid_domain_format: 'Invalid domain format.',
    /** UNTRANSLATED */
    duplicate_connector_name: 'Connector name already exists. Please choose a different name.',
};
export default Object.freeze(single_sign_on);
